<script lang="ts">
  import type { NewsLatestPosts, NewsPosts } from '$lib/sanity/schemas';
  import { ResponsiveVars, TwistStack } from '@twist/core';
  import { latestPostsStore } from '$lib/news/latestPosts/store';
  import Item from './Item.svelte';
  import { toFluidVarInput } from '$lib/utils/fluidity';
  import { useQuery } from '@sanity/svelte-loader';
  import { GetLatestPostsQuery } from '$lib/sanity/queries/news/newsPost';

  let { document }: { document: NewsLatestPosts } = $props();

  const latestPostId = $derived(document.itemId || document._id);
  const posts = $derived($latestPostsStore[latestPostId]?.data);
  const params = $derived($latestPostsStore[latestPostId]?.params);
  const latestPostsSourceMap = $derived($latestPostsStore[latestPostId]?.sourceMap);

  const query = $derived(
    useQuery<NewsPosts>(
      GetLatestPostsQuery,
      { ...params, ids: params?.skipIds },
      { initial: posts }
    )
  );

  const latestPosts = $derived($query.data);

  const responsiveVars = new ResponsiveVars()
    .addFluid('font-size', toFluidVarInput(16, 24))
    .addFluid('spacer', toFluidVarInput(24, 24))
    .toCSS();
</script>

<h2 class={responsiveVars}>Recent Posts</h2>
<TwistStack
  direction="column"
  align="stretch"
  justify="space-between"
  spacing={toFluidVarInput(36, 36)}
>
  {#if latestPosts}
    {#each latestPosts as post, index}
      <Item
        {post}
        sourceMap={latestPostsSourceMap}
        path={[index]}
        headlineSize={document.headlineSize}
      />
    {/each}
  {/if}
</TwistStack>

<style lang="scss">
  @import 'src/scss/variables';

  h2 {
    font-size: var(--font-size);
    font-family: var(--font-family-primary);
    font-weight: 700;
    line-height: 120%;
    color: $text-default-color;
    margin-bottom: var(--spacer);
  }
</style>
